import React from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '@/config/authConfig';
import { Button, Box, Typography, Paper } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';

import microsoft_logo from '/assets/images/logo/microsoft.webp';

export const LoginButton: React.FC = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogin = () => {
    instance.loginPopup(loginRequest).then(() => {
      // After successful login, redirect to intended route or default to /workflows
      const intendedRoute = sessionStorage.getItem('intendedRoute');
      if (intendedRoute) {
        sessionStorage.removeItem('intendedRoute');
        navigate(intendedRoute, { replace: true });
      } else {
        navigate('/workflows', { replace: true });
      }
    }).catch((e) => {
      console.error(e);
    });
  };

  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      size="large"
      sx={{ flex: 1, whiteSpace: 'nowrap' }}
      startIcon={
        <Box
          component="img"
          src={microsoft_logo}
          alt="Microsoft logo"
          sx={{ height: 21, width: 21 }}
        />
      }
      onClick={handleLogin}
    >
      Sign in with Microsoft
    </Button>
  );
};

export const LogoutButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    // Clear local cache to sign out from this app only
    // This keeps the user signed into Microsoft for other apps
    instance.clearCache();
    // Redirect to login page
    window.location.href = '/';
  };

  return (
    <Button
      variant="outlined"
      startIcon={<LogoutIcon />}
      onClick={handleLogout}
      sx={{ ml: 2 }}
    >
      Sign Out
    </Button>
  );
};

export const LoginPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Clarivate Content Canvas
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Please sign in to access the Workflow Management system
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <LoginButton />
        </Box>
      </Paper>
    </Box>
  );
};
